import React from 'react'
import { Dialog } from 'primereact/dialog'

import './CustomModal.css'

export default function CustomModal({
  children,
  header,
  isVisible,
  onClose,
  maximizable = false,
  maximized = undefined,
  onMaximize = undefined,
  width = null,
  style,
  contentStyle = null,
}) {
  return (
    <div className="CustomModal">
      <Dialog
        style={{ width: width ? width : '', ...style }}
        contentStyle={contentStyle}
        maximizable={maximizable}
        maximized={maximized}
        onMaximize={onMaximize}
        header={header}
        visible={isVisible}
        modal={true}
        onHide={onClose}
      >
        {children}
      </Dialog>
    </div>
  )
}
